import { render, staticRenderFns } from "./ntpReport.vue?vue&type=template&id=2d596bd0&"
import script from "./ntpReport.vue?vue&type=script&lang=js&"
export * from "./ntpReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports